import { EmployeeActionTypes } from './employee.types'

//Add Employee
export const addEmployeeRequest = data => ({
    type: EmployeeActionTypes.ADD_EMPLOYEE_REQUEST,
    payload: data
})

export const addEmployeeRequestSuccess = data => ({
    type: EmployeeActionTypes.ADD_EMPLOYEE_REQUEST_SUCCESS,
    payload: data
})

export const addEmployeeRequestError = data => ({
    type: EmployeeActionTypes.ADD_EMPLOYEE_REQUEST_ERROR,
    payload: data
})

export const addEmployeeRequestStatus = data => ({
    type: EmployeeActionTypes.ADD_EMPLOYEE_REQUEST_STATUS,
    payload: data
})

//Employee list
export const employeeListRequest = data => ({
    type: EmployeeActionTypes.EMPLOYEE_LIST_REQUEST,
    payload: data
})

export const employeeListRequestSuccess = data => ({
    type: EmployeeActionTypes.EMPLOYEE_LIST_REQUEST_SUCCESS,
    payload: data
})

export const employeeListRequestError = data => ({
    type: EmployeeActionTypes.EMPLOYEE_LIST_REQUEST_ERROR,
    payload: data
})

//Employee detail
export const employeeDetailRequest = data => ({
    type: EmployeeActionTypes.EMPLOYEE_DETAIL_REQUEST,
    payload: data
})

export const employeeDetailRequestSuccess = data => ({
    type: EmployeeActionTypes.EMPLOYEE_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const employeeDetailRequestError = data => ({
    type: EmployeeActionTypes.EMPLOYEE_DETAIL_REQUEST_ERROR,
    payload: data
})

//Update details
export const employeeUpdateDetailsRequest = data => ({
    type: EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST,
    payload: data
})

export const employeeUpdateDetailsRequestSuccess = data => ({
    type: EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST_SUCCESS,
    payload: data
})

export const employeeUpdateDetailsRequestError = data => ({
    type: EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST_ERROR,
    payload: data
})

export const employeeUpdateDetailsRequestStatus = data => ({
    type: EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST_STATUS,
    payload: data
})

//Employee clock in
export const employeeClockInRequest = data => ({
    type: EmployeeActionTypes.CLOCK_IN_REQUEST,
    payload: data
})

export const employeeClockInRequestSuccess = data => ({
    type: EmployeeActionTypes.CLOCK_IN_REQUEST_SUCCESS,
    payload: data
})

export const employeeClockInRequestError = data => ({
    type: EmployeeActionTypes.CLOCK_IN_REQUEST_ERROR,
    payload: data
})

export const employeeClockInRequestStatus = data => ({
    type: EmployeeActionTypes.CLOCK_IN_REQUEST_STATUS,
    payload: data
})

//Employee clock out
export const employeeClockOutRequest = data => ({
    type: EmployeeActionTypes.CLOCK_OUT_REQUEST,
    payload: data
})

export const employeeClockOutRequestSuccess = data => ({
    type: EmployeeActionTypes.CLOCK_OUT_REQUEST_SUCCESS,
    payload: data
})

export const employeeClockOutRequestError = data => ({
    type: EmployeeActionTypes.CLOCK_OUT_REQUEST_ERROR,
    payload: data
})

export const employeeClockOutRequestStatus = data => ({
    type: EmployeeActionTypes.CLOCK_OUT_REQUEST_STATUS,
    payload: data
})

//Employee attendance
export const employeeAttendanceListRequest = data => ({
    type: EmployeeActionTypes.EMPLOYEE_ATTENDANCE_LIST_REQUEST,
    payload: data
})

export const employeeAttendanceListRequestSuccess = data => ({
    type: EmployeeActionTypes.EMPLOYEE_ATTENDANCE_LIST_REQUEST_SUCCESS,
    payload: data
})

export const employeeAttendanceListRequestError = data => ({
    type: EmployeeActionTypes.EMPLOYEE_ATTENDANCE_LIST_REQUEST_ERROR,
    payload: data
})

//Add Employee availability
export const addEmployeeAvailabilityRequest = data => ({
    type: EmployeeActionTypes.ADD_AVAILABILITY_REQUEST,
    payload: data
})

export const addEmployeeAvailabilityRequestSuccess = data => ({
    type: EmployeeActionTypes.ADD_AVAILABILITY_REQUEST_SUCCESS,
    payload: data
})

export const addEmployeeAvailabilityRequestError = data => ({
    type: EmployeeActionTypes.ADD_AVAILABILITY_REQUEST_ERROR,
    payload: data
})

export const addEmployeeAvailabilityRequestStatus = data => ({
    type: EmployeeActionTypes.ADD_AVAILABILITY_REQUEST_STATUS,
    payload: data
})

//Employee availability list
export const employeeAvailabilityListRequest = data => ({
    type: EmployeeActionTypes.AVAILABILITY_LIST_REQUEST,
    payload: data
})

export const employeeAvailabilityListRequestSuccess = data => ({
    type: EmployeeActionTypes.AVAILABILITY_LIST_REQUEST_SUCCESS,
    payload: data
})

export const employeeAvailabilityListRequestError = data => ({
    type: EmployeeActionTypes.AVAILABILITY_LIST_REQUEST_ERROR,
    payload: data
})

//Update Employee availability
export const updateEmployeeAvailabilityRequest = data => ({
    type: EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST,
    payload: data
})

export const updateEmployeeAvailabilityRequestSuccess = data => ({
    type: EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST_SUCCESS,
    payload: data
})

export const updateEmployeeAvailabilityRequestError = data => ({
    type: EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST_ERROR,
    payload: data
})

export const updateEmployeeAvailabilityRequestStatus = data => ({
    type: EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST_STATUS,
    payload: data
})

//Remove employee from business
export const removeEmployeeFromBusinessRequest = data => ({
    type: EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST,
    payload: data
})

export const removeEmployeeFromBusinessRequestSuccess = data => ({
    type: EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST_SUCCESS,
    payload: data
})

export const removeEmployeeFromBusinessRequestError = data => ({
    type: EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST_ERROR,
    payload: data
})

export const removeEmployeeFromBusinessRequestStatus = data => ({
    type: EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST_STATUS,
    payload: data
})

//Dashboard data
export const employeeDashboardRequest = data => ({
    type: EmployeeActionTypes.EMPLOYEE_DASHBOARD_DATA_REQUEST,
    payload: data
})

export const employeeDashboardRequestSuccess = data => ({
    type: EmployeeActionTypes.EMPLOYEE_DASHBOARD_DATA_REQUEST_SUCCESS,
    payload: data
})

export const employeeDashboardRequestError = data => ({
    type: EmployeeActionTypes.EMPLOYEE_DASHBOARD_DATA_REQUEST_ERROR,
    payload: data
})

//Login Code check
export const employeeLoginCodeCheckRequest = data => ({
    type: EmployeeActionTypes.LOGIN_CODE_CHECK_REQUEST,
    payload: data
})

export const employeeLoginCodeCheckRequestSuccess = data => ({
    type: EmployeeActionTypes.LOGIN_CODE_CHECK_REQUEST_SUCCESS,
    payload: data
})

export const employeeLoginCodeCheckRequestError = data => ({
    type: EmployeeActionTypes.LOGIN_CODE_CHECK_REQUEST_ERROR,
    payload: data
})

//Clear login Code check
export const clearEmployeeLoginCodeCheck = data => ({
    type: EmployeeActionTypes.CLEAR_LOGIN_CODE_CHECK,
    payload: data
})

//Attendance check
export const employeeAttendanceCheckRequest = data => ({
    type: EmployeeActionTypes.EMPLOYEE_ATTENDANCE_CHECK_REQUEST,
    payload: data
})

export const employeeAttendanceCheckRequestSuccess = data => ({
    type: EmployeeActionTypes.EMPLOYEE_ATTENDANCE_CHECK_REQUEST_SUCCESS,
    payload: data
})

export const employeeAttendanceCheckRequestError = data => ({
    type: EmployeeActionTypes.EMPLOYEE_ATTENDANCE_CHECK_REQUEST_ERROR,
    payload: data
})